import { connect } from 'react-redux';
import HeaderRow from '../components/header_row';
import { selectIsManagerSite, selectParentEvent, selectDisplayedFlags, selectVisibleColumns } from '../selectors'

const mapStateToProps = (state, ownProps) => {
  const eventId = String(ownProps.eventId);
  const parentEvent = selectParentEvent(state, eventId);
  const event = state.event?.[eventId];
  const data = event?.data || null;

  return {
    data,
    handicapFormat: parentEvent?.handicapFormat ?? null,
    columns: selectVisibleColumns(state, eventId),
    roundToParTitle: data?.roundToParTitle ?? null,
    roundThruTitle: data?.roundThruTitle ?? null,
    displayedFlags: selectDisplayedFlags(state, eventId),
    isManagerSite: selectIsManagerSite(state),
  };
};

export default connect(mapStateToProps)(HeaderRow);
